<mifosx-group-assign-staff *ngIf="actions['Assign Staff']"></mifosx-group-assign-staff>
<mifosx-close-group *ngIf="actions['Close']"></mifosx-close-group>
<mifosx-activate-group *ngIf="actions['Activate']"></mifosx-activate-group>
<mifosx-attach-group-meeting *ngIf="actions['Attach Meeting']"></mifosx-attach-group-meeting>
<mifosx-group-attendance *ngIf="actions['Attendance']"></mifosx-group-attendance>
<mifosx-manage-group-members *ngIf="actions['Manage Members']"></mifosx-manage-group-members>
<mifosx-edit-group-meeting *ngIf="actions['Edit Meeting']"></mifosx-edit-group-meeting>
<mifosx-edit-group-meeting-schedule *ngIf="actions['Edit Meeting Schedule']"></mifosx-edit-group-meeting-schedule>
<mifosx-group-transfer-clients *ngIf="actions['Transfer Clients']"></mifosx-group-transfer-clients>
